import { CSSObject, Theme } from '@emotion/react';
import { mobile } from 'styles/media';

const wrap = (theme: Theme): CSSObject => ({
  width: '100%',
  minHeight: '100vh',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 24,
  padding: '40px 20px',
  background: theme.color.background,
  [mobile]: {
    justifyContent: 'flex-start',
    padding: '72px 24px calc(24px + env(safe-area-inset-bottom))',
    background: theme.color.white,
  },
});

const card = (theme: Theme): CSSObject => ({
  width: 420,
  maxWidth: '100%',
  boxSizing: 'border-box',
  padding: '44px 40px 40px',
  background: theme.color.white,
  borderRadius: theme.radius.xl + 8,
  '> form': {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  [mobile]: {
    width: '100%',
    padding: 0,
    borderRadius: 0,
  },
});

const logo: CSSObject = {
  display: 'block',
  height: 26,
  width: 'auto',
  marginBottom: 24,
};

const eyebrow = (theme: Theme): CSSObject => ({
  marginBottom: 8,
  fontSize: 14,
  fontWeight: 600,
  color: theme.color.textMuted,
});

const title = (theme: Theme): CSSObject => ({
  marginBottom: 32,
  fontSize: 24,
  fontWeight: 700,
  lineHeight: 1.45,
  letterSpacing: '-0.02em',
  color: theme.color.text,
  wordBreak: 'keep-all',
  [mobile]: {
    fontSize: 22,
    marginBottom: 40,
  },
});

const label = (theme: Theme): CSSObject => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  '> span': {
    fontSize: 13,
    fontWeight: 600,
    color: theme.color.grey600,
  },
});

const inpuyStyle = (theme: Theme): CSSObject => ({
  width: '100%',
  height: '56px',
  padding: '0 16px',
  fontSize: '16px',
  border: '2px solid transparent',
  borderRadius: theme.radius.md + 2,
  background: theme.color.grey75,
  ':hover:not(:disabled):not(:read-only)': {
    borderColor: 'transparent',
  },
  ':focus': {
    outline: 'none',
    background: theme.color.white,
    borderColor: theme.color.primary,
    boxShadow: 'none',
  },
  '::placeholder': {
    color: theme.color.grey400,
    fontSize: '16px',
  },
});

const submit = (theme: Theme): CSSObject => ({
  width: '100%',
  height: '56px',
  marginTop: 16,
  borderRadius: theme.radius.md + 2,
  fontSize: '17px',
  fontWeight: 600,
  background: theme.color.primary,
  color: theme.color.white,
  transition: 'background-color 0.15s ease, transform 0.1s ease',
  ':hover': {
    background: theme.color.primaryHover,
  },
  ':active': {
    transform: 'scale(0.99)',
  },
  [mobile]: {
    marginTop: 24,
  },
});

const footer = (theme: Theme): CSSObject => ({
  fontSize: 12,
  color: theme.color.textMuted,
  [mobile]: {
    marginTop: 'auto',
  },
});

export { wrap, card, logo, eyebrow, title, label, inpuyStyle, submit, footer };
